import React, { useState } from 'react'

import useCompanyConfig from './hooks/api/useCompanyConfig'
import { Box, Button, IconButton, Typography } from '@mui/material'
import useIsAdmin from './hooks/useIsAdmin'
import { orange } from '@mui/material/colors'
import { Cancel } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { steps as WIZARD_STEPS } from './setupWizard/Wizard'
import useIsMobile from './hooks/useIsMobile'

const SetupWatcher = ({ navOpen }) => {
  const { companyConfig, isLoading } = useCompanyConfig()
  const { isAdmin } = useIsAdmin()
  const [isDismissed, setIsDismissed] = useState(false)

  const navigate = useNavigate()
  const isMobile = useIsMobile()

  if (isLoading || isDismissed) return null

  const wizardSteps = companyConfig?.wizardSteps

  const hasCompletedSetup =
    !wizardSteps ||
    WIZARD_STEPS.every((s) => {
      return (
        wizardSteps[s.path] === 'COMPLETE' || wizardSteps[s.path] === 'SKIPPED'
      )
    })

  if (hasCompletedSetup) return null

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 2,
        backgroundColor: orange[50],
        position: 'fixed',
        bottom: isMobile ? 70 : 0,
        right: 0,
        left: 0,
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1000,
        left: isMobile ? 0 : navOpen ? '246px' : '93px',
        transition: 'all 0.225s',
      }}
    >
      <Box />
      <Box sx={{ px: 2, display: 'flex', alignItems: 'center', mt: -2 }}>
        <Typography sx={{ mt: 2 }}>
          StartupCRM has not been fully set up
          {!isAdmin && ' by your administrator'}. Performance may suffer
        </Typography>
        {isAdmin && (
          <Button
            sx={{ m: 2, mb: 0 }}
            variant={'outlined'}
            onClick={() => navigate('/setup')}
          >
            Finish setting up
          </Button>
        )}
      </Box>
      <IconButton onClick={() => setIsDismissed(true)} sx={{ mr: 2 }}>
        <Cancel />
      </IconButton>
    </Box>
  )
}

export default SetupWatcher
